import React from 'react';
 
const Pagination = ({ nPages, currentPage, setCurrentPage }) => {
    const maxPageNumbersToShow = 10;
    const halfMaxPagesToShow = Math.floor(maxPageNumbersToShow / 2);
 
    let startPage, endPage;
    if (nPages <= maxPageNumbersToShow) {
        startPage = 1;
        endPage = nPages;
    } else {
        if (currentPage <= halfMaxPagesToShow) {
            startPage = 1;
            endPage = maxPageNumbersToShow;
        } else if (currentPage + halfMaxPagesToShow >= nPages) {
            startPage = nPages - maxPageNumbersToShow + 1;
            endPage = nPages;
        } else {
            startPage = currentPage - halfMaxPagesToShow;
            endPage = currentPage + halfMaxPagesToShow;
        }
    }
 
    const pageNumbers = [...Array((endPage - startPage) + 1).keys()].map(i => startPage + i);
 
    const goToNextPage = () => {
        if (currentPage !== nPages) setCurrentPage(currentPage + 1);
    };
    const goToPrevPage = () => {
        if (currentPage !== 1) setCurrentPage(currentPage - 1);
    };
 
    return (
        <nav>
            <ul className='pagination justify-content-center'>
                <li className={`page-item-containt ${currentPage === 1 ? 'disabled' : ''}`}>
                    <a className="page-link-containt" onClick={goToPrevPage} href='#'>
                        Previous
                    </a>
                </li>
                {pageNumbers.map(pgNumber => (
                    <li key={pgNumber} className={`page-item-containt ${currentPage === pgNumber ? 'activePage' : ''}`}>
                        <a onClick={() => setCurrentPage(pgNumber)} className='page-link-containt' href='#'>
                            {pgNumber}
                        </a>
                    </li>
                ))}
                <li className={`page-item-containt ${currentPage === nPages ? 'disabled' : ''}`}>
                    <a className="page-link-containt" onClick={goToNextPage} href='#'>
                        Next
                    </a>
                </li>
            </ul>
        </nav>
    );
};
 
export default Pagination;